"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6875],{

/***/ 6875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticleChart; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ArticleChart.js



const p = "chart", E = "desktop", x = "chart__table", u = "chart__credits", y = "chart__source", c = {
  chart: p,
  desktop: E,
  chartTable: x,
  chartCredits: u,
  chartSource: y
};
function _({
  caption: l,
  thKey: n,
  thValue: o,
  rows: d,
  credits: m,
  source: h
}) {
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.NONE,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      "data-testid": "article-page-chart"
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, null, /* @__PURE__ */ react.createElement("div", { className: c.chart }, /* @__PURE__ */ react.createElement("table", { className: c.chartTable, cellSpacing: 0 }, !!l && /* @__PURE__ */ react.createElement("caption", { className: app_a75c1d35.t.textsBodyTextBold }, l), /* @__PURE__ */ react.createElement("thead", null, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement("th", { className: app_a75c1d35.t.textsBodyTextBold }, n), /* @__PURE__ */ react.createElement("th", { className: app_a75c1d35.t.textsBodyTextBold }, o))), /* @__PURE__ */ react.createElement("tbody", null, d.map((r, i) => /* @__PURE__ */ react.createElement("tr", { key: i + r.tdKey }, /* @__PURE__ */ react.createElement("td", { className: app_a75c1d35.t.textsBodyText }, r.tdKey), /* @__PURE__ */ react.createElement("td", { className: app_a75c1d35.t.textsBodyText }, r.tdValue))))), /* @__PURE__ */ react.createElement("span", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsCaption, c.chartCredits) }, m), /* @__PURE__ */ react.createElement("span", { className: (0,app_a75c1d35.c)(app_a75c1d35.t.textsCaption, c.chartSource) }, h)))
  );
}

//# sourceMappingURL=ArticleChart.js.map

// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticleChart/ArticleChart.tsx



function ArticleChart(param) {
    var caption = param.caption, thKey = param.thKey, thValue = param.thValue, tableData = param.tableData, credits = param.credits, source = param.source;
    var rows = (0,magnolia/* jcrMultiFieldToArray */.FE)(tableData).map(function(tableDataNode) {
        return {
            tdKey: tableDataNode.tdKey,
            tdValue: tableDataNode.tdValue
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_, {
        caption: caption,
        thKey: thKey,
        thValue: thValue,
        rows: rows,
        credits: credits,
        source: source
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticleChart/index.ts
/* istanbul ignore file */ 


/***/ })

}]);